
import { apiFetch } from "../_utils/apiInterceptor.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = `${backendUrl}/api/v1/products`;

export const get = async ({productId = "all", status = "ACTIVE"}) => {
  return await apiFetch(
    `${BASE_URL}/?productId=${productId}&status=${status}`,
    {
      method: "GET"
    }
  );
};

export const getById = async (productId) => {
  return await apiFetch(
    `${BASE_URL}/get/${productId}`,
    {
      method: "GET"
    }
  );
};
